<template>
    <div>
        <q-inner-loading :showing="getOrderPending || loading">
            <div>
                <q-spinner color="primary"
                           :thickness="2"
                           size="3em" />
            </div>
        </q-inner-loading>
    </div>
</template>
<script>
    import { mapState } from 'vuex'

    export default {
        name: 'order-confirm',
        props: {
            id: String,
        },
        data() {
            this.maxAttempts = 10
            return {
                numAttempt: 0,
                loading: true,
            }
        },
        methods: {

            getOrder() {
                if (this.numAttempt >= this.maxAttempts)
                    this.$router.push('/404').catch(err => { })

                this.$store.dispatch('getOrder', this.id).then(() => {
                    if (!this.getOrderData || this.getOrderData.status !== 3) {
                        if (this.numAttempt < this.maxAttempts) {
                            setTimeout(() => { this.getOrder() }, 10000)
                            this.numAttempt += 1
                        } else {
                            this.$store.commit('reset_cart')
                            this.$router.push({ name: '/myaccount/orders/order-details', params: { id: this.id } })
                            this.loading = false
                        }
                    } else {
                        this.postBenchmarkEmail(this.getOrderData)

                        this.$store.commit('reset_cart')
                        this.$router.push({ name: '/myaccount/orders/order-details', params: { id: this.id } })
                        this.loading = false
                    }
                }).catch(err => {
                    setTimeout(() => { this.getOrder() }, 10000)
                    this.numAttempt += 1
                })
            },
            postBenchmarkEmail(orderData) {

                const payload = {
                    email: orderData.email,
                    firstName: orderData.firstName,
                    lastName: orderData.lastName,
                    orderID: orderData.orderID
                }

                this.$store.dispatch('submitOrderContactToBenchmark', payload)

            },

        },
        computed: {
            ...mapState([
                'getOrderPending',
                'getOrderData',
            ]),

        },
        created() {
            if (this.id) {
                this.getOrder()
            }
        },
    }
</script>
